module.exports = __webpack_public_path__ + "img/92_instrument.32b0259e.jpg";